export function initCircleProgress() {
    const firstSectionLabel = document.querySelector(".section-label.first");
    if (firstSectionLabel) {
        window.addEventListener("scroll", function() {
            const circleProgress = document.querySelector(".circle-progress");
            if (hasPassedBottomOfDiv(firstSectionLabel)) {
                circleProgress.classList.add("d-md-block");
                circleProgress.classList.remove("d-md-none");
                const bottomDiff = Math.min(bottomDivDiff(firstSectionLabel) / 1.1, 300);
                if (bottomDiff < 300) {
                    circleProgress.style.setProperty("--bottom-y", `${bottomDiff}px`);
                }
            } else {
                circleProgress.classList.add("d-md-none");
                circleProgress.classList.remove("d-md-block");
            }
        })
    }
}

export function initMouseMove() {
    const firstSectionLabel = document.querySelector(".section-label.first");
    if (firstSectionLabel) {
        window.addEventListener("mousemove", function(e) {
            const circleProgress = document.querySelector(".circle-progress");
            const bottom = e.clientY;
            const rect = firstSectionLabel.getBoundingClientRect();
            if (rect.bottom <= bottom && hasPassedBottomOfDiv(firstSectionLabel) && !isEnd(e)) {
                circleProgress.style.setProperty("--bottom-y", `${window.innerHeight - bottom}px`);
            } else {
                circleProgress.style.display = "none!important";
            }
        })
    }
}

export function initActiveLabels() {
    let observer = new IntersectionObserver(function (entries, observer) {
        for (let entry of entries) {
            if (entry.isIntersecting) {
                entry.target.classList.add("active");
            } else {
                entry.target.classList.remove("active");
            }
        }
    });

    let headings = document.querySelectorAll('.section-label');

    for (let heading of headings) {
        observer.observe(heading);
    }
}

function hasPassedBottomOfDiv(divElement) {
    const rect = divElement.getBoundingClientRect();
    return rect.bottom <= window.innerHeight;
}

function isEnd(e) {
    return e.pageY >= (document.documentElement.scrollHeight - 130)
}

function bottomDivDiff(divElement) {
    const rect = divElement.getBoundingClientRect();
    return window.innerHeight - rect.bottom;
}